import { EduContentMetadataInterface } from './EduContentMetadata.interface';

export enum EduContentProductTypeCode {
  VIDEO = 'video',
  SIMULATION = 'simulation',
  GAME = 'game',
  PROBLEM = 'problem',
  SOLUTION = 'solution',
}

/** Whether a product type is printable (Probleem/Correctiesleutel) and therefore requires a print template. */
export function isPrintableProductTypeCode(code: EduContentProductTypeCode | undefined): boolean {
  return code === EduContentProductTypeCode.PROBLEM || code === EduContentProductTypeCode.SOLUTION;
}

export interface EduContentProductTypeInterface {
  name: string;
  icon?: string;
  pedagogic?: boolean;
  excludeFromFilter?: boolean;
  id?: number;
  parent?: number;
  eduContentMetadata?: EduContentMetadataInterface[];
  sequence?: number;
  code?: EduContentProductTypeCode;
  isPracticeMaterial?: boolean;
}
